<div [formGroup]="group"><input [formControlName]="formControlName" type="hidden" [name]="name" [value]="value" /></div>
